export let config = {
	panel: [
		{
			id: 100,
			type: "engine",
			title: {
				en: "Gearbox",
				de: "Gearbox",
			},
			info: null,
			image: "/apps/configurators/omnicare/assets/images/Gearbox.svg",
			categories: [1],
			engines: [],
			children: [],
			description:
				"Marine gearboxes are subjected to harsh operating conditions, including high torque, variable loads, and exposure to water and marine environments. Proper maintenance is essential to ensure their reliability, longevity, and optimal performance.<br><br>After 50,000 running hours or 10 years, a major overhaul of the gearbox is recommended, including:<ul><li>Replacing bearings</li><li>Servicing and replacing filters</li><li>Maintaining clutch control</li><li>Replacing the pressure relief valve</li><li>Inspecting and servicing other components specific to the gearbox type</li></ul>",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
				{
					text: {
						en: "Download brochure",
						de: "Download brochure",
					},
					url: "/apps/configurators/omnicare/assets/pdfs/EVR000298EN-250800_L3_Omnicare_RENK_LOW.pdf",
					mode: "",
					type: "external",
				},
			],
		},
		{
			id: 101,
			type: "engine",
			title: {
				en: "EGR blower",
				de: "EGR blower",
			},
			info: null,
			image: "/apps/configurators/omnicare/assets/images/EGR_Blower.svg",
			categories: [2, 3],
			engines: [],
			children: [],
			description:
				"The EGR blower is a key component of the Exhaust Gas Recirculation (EGR) system, ensuring efficient gas flow from the exhaust receiver to the scavenge air receiver—up to 40% of total exhaust gas volume.<br><br>Key functions:<ul><li>Overcomes pressure differences between exhaust and intake systems.</li><li>Compensates for pressure losses in EGR components.</li><li>Controlled by a frequency converter for precise flow management.</li></ul><br>By optimizing gas recirculation, the EGR blower plays a vital role in reducing NOₓ emissions and enhancing environmental performance.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
			],
		},
		{
			id: 102,
			type: "engine",
			title: {
				en: "Turbocharger",
				de: "Turbocharger",
			},
			info: "Globally authorized by MET and authorized at selected PrimeServ locations by other partner brands.",
			image: "/apps/configurators/omnicare/assets/images/Turbocharger.svg",
			categories: [4, 5, 6],
			engines: [],
			children: [],
			description:
				"With centuries of experience in servicing and repairing Everllence turbochargers, we offer expert maintenance and repair solutions for a wide range of turbocharger brands at our global service locations<ul><li>Maintenance and repair of axial and radial turbochargers</li><li>Pre-drydock inspections of axial turbochargers</li><li>Exchange-based service solutions</li><li>Consignment stock management</li></ul>",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
				{
					text: {
						en: "More about MET turbocharger",
						de: "More about MET turbocharger",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/omnicare-3rd-party-services/met-turbocharger",
					mode: "",
					type: "",
				},
			],
		},
		{
			id: 103,
			type: "engine",
			title: {
				en: "Offline lubrication oil filter",
				de: "Offline lubrication oil filter",
			},
			info: "Authorized by C.C.JENSEN.",
			image:
				"/apps/configurators/omnicare/assets/images/Lubrication_oil_filter.svg",
			categories: [33, 34, 35],
			engines: [],
			children: [],
			description:
				"Effective lube oil filtration is crucial for maintaining engine performance, preventing wear, and extending the lifespan of critical components. Inline filters act as a safety filter but deep cleaning of the oil is done with an offline filter.<ul><li>Expert support and advice in selecting the ideal filtration system</li><li>Retrofit installations, spare parts, and replacement filter inserts with quick delivery</li><li>Return on Investment (ROI) calculation to assess potential savings than can be expected.</li></ul>",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
				{
					text: {
						en: "More about C.C.Jensen",
						de: "More about C.C.Jensen",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/omnicare-3rd-party-services/cc-jensen",
					mode: "",
					type: "",
				},
			],
		},
		{
			id: 104,
			type: "engine",
			title: {
				en: "Governors & actuators",
				de: "Governors & actuators",
			},
			info: "Globally authorized by Regulateurs Europa and authorized by Woodward at selected PrimeServ locations.",
			image:
				"/apps/configurators/omnicare/assets/images/Governors_Actuators.svg",
			categories: [10, 11, 12],
			engines: [],
			children: [],
			description:
				"Governors and actuators should be overhauled during a major engine overhaul, after 20,000 operating hours, or at least every 5 years to prevent seal leakage, even with low running hours.<br><br>Our services include the exchange of governors and actuators for Everllence and non-Everllence Four-stroke engines.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
			],
		},
		{
			id: 105,
			type: "engine",
			title: {
				en: "Mounts",
				de: "Mounts",
			},
			info: null,
			image: "/apps/configurators/omnicare/assets/images/Mounts.svg",
			categories: [13, 14, 15],
			engines: [],
			children: [],
			description:
				"During major repairs or overhauls, engine mounts should be inspected for wear and proper alignment. If necessary, they can be adjusted or replaced to ensure secure positioning and reliable engine operation.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
			],
		},
		{
			id: 106,
			type: "engine",
			title: {
				en: "Flexible coupling",
				de: "Flexible coupling",
			},
			info: "Globally authorized by CENTA and authorized by Vulkan and Geislinger at selected PrimeServ locations.",
			image: "/apps/configurators/omnicare/assets/images/Flexible_Coupling.svg",
			categories: [6, 15, 16],
			engines: [],
			children: [],
			description:
				"A coupling is a mechanical device used to connect two shafts together to transmit power and motion while accommodating misalignment and reducing vibrations. The rubber coupling should be inspected after 1,000 and 4,000 operating hours, and then every 6,000 operating hours or annually, whichever comes first. After 10 years or 50,000 running hours, the rubber segment should be replaced.<ul><li>Annual inspections of couplings</li><li>Rubber element replacements and repairs across the product line</li><li>Alignment checks (including engine or propulsion foundation)</li><li>Resilient mounting replacements</li></ul>",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
				{
					text: {
						en: "More about CENTA couplings",
						de: "More about CENTA couplings",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/omnicare-3rd-party-services/centa-couplings",
					mode: "",
					type: "",
				},
			],
		},
		{
			id: 107,
			type: "engine",
			title: {
				en: "Alternator",
				de: "Alternator",
			},
			info: "Authorized by INDAR at selected PrimeServ service locations.",
			image: "/apps/configurators/omnicare/assets/images/Alternator.svg",
			categories: [17, 18],
			engines: [],
			children: [],
			description:
				"Alternator manufacturers define maintenance schedules based on stress factors such as electrical, mechanical, thermal, and environmental conditions. Maintenance intervals depend on running hours and the number of starts, with each start roughly equating to 50 hours of running time, ensuring maximum reliability and performance.<ul><li>Alternator rewinding at the customer site</li><li>Rotor pole replacement and rewinding</li><li>Stator crimped joint issue rectification</li><li>Commissioning and troubleshooting</li></ul>",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
			],
		},
		{
			id: 109,
			type: "engine",
			title: {
				en: "Power take-off",
				de: "Power take-off",
			},
			info: null,
			image: "/apps/configurators/omnicare/assets/images/PTO.svg",
			categories: [19, 20],
			engines: [],
			children: [],
			description:
				"The PTO transfers power from the main engine to auxiliary systems, optimizing space and fuel efficiency.<ul><li>Inspection</li><li>Installation and commissioning</li><li>Check alignment, lubrication, wear on bearings, seals, and clutches</li><li>System performance tuning and optimization</li><li>Advanced diagnostics and failure analysis</li></ul>",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
			],
		},
		{
			id: 110,
			type: "engine",
			title: {
				en: "Hydraulic pump",
				de: "Hydraulic pump",
			},
			info: null,
			image: "/apps/configurators/omnicare/assets/images/Hydraulic_pumps.svg",
			categories: [20, 21],
			engines: [],
			children: [],
			description:
				"A hydraulic pump converts mechanical energy from the engine into hydraulic power for high and low presure systems on the engine. This hydraulic pressure is utelized for lube oil circulation and hydraulic control of the engine. Regular checks and periodic overalls of hydraulic pumps help maintain the reliability and efficiency of the vessel's systems to ensure optimal performance and prevent system failures.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontakt aufnehmen",
					},
					url: "#contact",
					mode: "fill",
					type: "",
				},
			],
		},
		{
			id: 2,
			type: "360-approach",
			title: {
				en: "Systems",
				de: "Systems",
			},
			info: null,
			image: "",
			categories: [22, 23, 24],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 111,
					type: "360-approach",
					title: {
						en: "Fuel filtration",
						de: "Fuel filtration",
					},
					info: null,
					image: null,
					categories: [22, 23, 24],
					engines: [],
					children: [],
					description:
						"Everllence, in collaboration with Boll Filters, offers a 10µm automatic backflush fuel filter. This filter effectively removes harmful catalytic fines (cat fines). Recent MARPOL regulations have led to an increase in cat fines in various fuels. Consequently, Everllence has issued several service letters advising customers to install these filters as a preventative measure to protect the combustion chamber area from cat fine-related damage.",
					links: [
						{
							text: {
								en: "Contact us for tailored solutions",
								de: "Kontakt aufnehmen",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about Boll & Kirch backflush filters",
								de: "More about Boll & Kirch backflush filters",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/omnicare-3rd-party-services/boll-and-kirch-backflush-filter",
							mode: "",
							type: "",
						},
					],
				},
				{
					id: 112,
					type: "360-approach",
					title: {
						en: "PMI recalibration",
						de: "PMI recalibration",
					},
					info: null,
					image: null,
					categories: [25],
					engines: [],
					children: [],
					description:
						"Boosting efficiency relies on optimizing energy conversion in the combustion chamber. Everllence aims to continuously improve combustion processes to save fuel and reduce CO₂ emissions. PMI (Performance Measurement Indicator) is an integrated part of the Engine Control System, required for the correct commissioning of the engine and operating the engine in service.<br><br>The calibration service takes place in Denmark in close cooperation with Kistler Nordic. The estimated service\ntime is 2 weeks from arrival at the facilities.",
					links: [
						{
							text: {
								en: "Contact us for tailored solutions",
								de: "Kontakt aufnehmen",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download brochure",
								de: "Download brochure",
							},
							url: "/apps/configurators/omnicare/assets/pdfs/EVR000296EN-250800_L3_Omnicare_PMI_Introduction_LOW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 3,
			type: "360-approach",
			title: {
				en: "Solutions",
				de: "Solutions",
			},
			info: null,
			image: "",
			categories: [26, 27, 28],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 114,
					type: "360-approach",
					title: {
						en: "Dry-docking services",
						de: "Dry-docking services",
					},
					info: null,
					image: null,
					categories: [29],
					engines: [],
					children: [],
					description:
						"Besides the engine, Everllence can support you on the maintenance and repair of turbochargers, couplings, gearbox, electrical system upgrade, lube oil system segregation and retrofits.",
					links: [
						{
							text: {
								en: "Contact us for tailored solutions",
								de: "Kontakt aufnehmen",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
				{
					id: 115,
					type: "360-approach",
					title: {
						en: "LTSAs, operations and maintenance",
						de: "LTSAs, operations and maintenance",
					},
					info: null,
					image: null,
					categories: [30, 31],
					engines: [],
					children: [],
					description:
						"A long-term service agreement opens up the Everllence service to the full extent. We plan and coordinate the turbocharger service on your behalf within the Everllence PrimeServ network. You benefit from an extended warranty and priority access for troubleshooting and spare part identification. This agreement is an all-in-one solution that saves you time and money.<br><br>This level of service not only comes with Everllence turbochargers: with Omnicare, you also gain access to Mitsubishi authorized service workshops around the globe. This package includes high-quality Maintenance Kits, official MET turbochargers, and trained service engineers. All Maintenance Kits are produced by Mitsubishi and are available on short notice from Japan.",
					links: [
						{
							text: {
								en: "Contact us for tailored solutions",
								de: "Kontakt aufnehmen",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
				{
					id: 116,
					type: "360-approach",
					title: {
						en: "High-speed engines and services",
						de: "High-speed engines and services",
					},
					info: "Authorized by Everllence Engines at selected PrimeServ service locations.",
					image: null,
					categories: [4, 32],
					engines: [],
					children: [],
					description:
						"High Speed is one more area where you can trust Everllence:<br><ul><li>Our own marine GenSet built based on MAN Truck&Bus engine,</li><li>Stationary diesel and gas gensets in cooperation with top packager (up to 4MW),</li><li>Spare parts and services of other HS engine brands.</li></ul><br>We choose most reliable, efficient, and sustainable solutions in high-speed engine market.",
					links: [
						{
							text: {
								en: "Contact us for tailored solutions",
								de: "Kontakt aufnehmen",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about Alpha GenSet",
								de: "More about Alpha GenSet",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/omnicare-3rd-party-services/alpha-genset",
							mode: "",
							type: "",
						},
					],
				},
			],
		},
	],
	pluses: [],
	categories: [
		{
			id: 1,
			type: "category",
			text: {
				en: "Gearbox overhaul",
				de: "Gearbox overhaul",
			},
		},
		{
			id: 2,
			type: "category",
			text: {
				en: "NOₓ Reduction",
				de: "NOₓ Reduction",
			},
		},
		{
			id: 3,
			type: "category",
			text: {
				en: "Tier III Compliance",
				de: "Tier III Compliance",
			},
		},
		{
			id: 4,
			type: "category",
			text: {
				en: "Maintenance",
				de: "Maintenance",
			},
		},
		{
			id: 5,
			type: "category",
			text: {
				en: "Repair",
				de: "Repair",
			},
		},
		{
			id: 6,
			type: "category",
			text: {
				en: "Inspections",
				de: "Inspections",
			},
		},
		{
			id: 7,
			type: "category",
			text: {
				en: "Filtration system",
				de: "Filtration system",
			},
		},
		{
			id: 8,
			type: "category",
			text: {
				en: "ROI calculation",
				de: "ROI calculation",
			},
		},
		{
			id: 9,
			type: "category",
			text: {
				en: "Retrofit",
				de: "Retrofit",
			},
		},
		{
			id: 10,
			type: "category",
			text: {
				en: "Overhaul",
				de: "Overhaul",
			},
		},
		{
			id: 11,
			type: "category",
			text: {
				en: "Four-stroke",
				de: "Four-stroke",
			},
		},
		{
			id: 12,
			type: "category",
			text: {
				en: "Preventive maintenance",
				de: "Preventive maintenance",
			},
		},
		{
			id: 13,
			type: "category",
			text: {
				en: "Inspection",
				de: "Inspection",
			},
		},
		{
			id: 14,
			type: "category",
			text: {
				en: "Alignment",
				de: "Alignment",
			},
		},
		{
			id: 15,
			type: "category",
			text: {
				en: "Replacement",
				de: "Replacement",
			},
		},
		{
			id: 16,
			type: "category",
			text: {
				en: "Vibration reduction",
				de: "Vibration reduction",
			},
		},
		{
			id: 17,
			type: "category",
			text: {
				en: "Commissioning",
				de: "Commissioning",
			},
		},
		{
			id: 18,
			type: "category",
			text: {
				en: "Troubleshooting",
				de: "Troubleshooting",
			},
		},
		{
			id: 19,
			type: "category",
			text: {
				en: "Optimization",
				de: "Optimization",
			},
		},
		{
			id: 20,
			type: "category",
			text: {
				en: "Diagnostics",
				de: "Diagnostics",
			},
		},
		{
			id: 21,
			type: "category",
			text: {
				en: "Upgrades",
				de: "Upgrades",
			},
		},
		{
			id: 22,
			type: "category",
			text: {
				en: "Fuel filtration",
				de: "Fuel filtration",
			},
		},
		{
			id: 23,
			type: "category",
			text: {
				en: "Cat fines removal",
				de: "Cat fines removal",
			},
		},
		{
			id: 24,
			type: "category",
			text: {
				en: "MARPOL Compliance",
				de: "MARPOL Compliance",
			},
		},
		{
			id: 25,
			type: "category",
			text: {
				en: "Combustion optimization",
				de: "Combustion optimization",
			},
		},
		{
			id: 26,
			type: "category",
			text: {
				en: "Engine upgrades",
				de: "Engine upgrades",
			},
		},
		{
			id: 27,
			type: "category",
			text: {
				en: "Hydraulic systems",
				de: "Hydraulic systems",
			},
		},
		{
			id: 28,
			type: "category",
			text: {
				en: "Global support",
				de: "Global support",
			},
		},
		{
			id: 29,
			type: "category",
			text: {
				en: "Comprehensive support",
				de: "Comprehensive support",
			},
		},
		{
			id: 30,
			type: "category",
			text: {
				en: "Global coverage",
				de: "Global coverage",
			},
		},
		{
			id: 31,
			type: "category",
			text: {
				en: "Priority access",
				de: "Priority access",
			},
		},
		{
			id: 32,
			type: "category",
			text: {
				en: "Spare parts",
				de: "Spare parts",
			},
		},
		{
			id: 33,
			type: "category",
			text: {
				en: "Fuel saving",
				de: "Fuel saving",
			},
		},
		{
			id: 34,
			type: "category",
			text: {
				en: "CO₂ reduction",
				de: "CO₂ reduction",
			},
		},
		{
			id: 35,
			type: "category",
			text: {
				en: "Easy oil cleaning",
				de: "Easy oil cleaning",
			},
		},
	],
	engines: [],
	cart: {
		title: {
			de: "bookmarked solutions",
			en: "bookmarked solutions",
		},
	},
	finder: {
		title: { de: "Engine Room / Powerhouse", en: "Engine Room / Powerhouse" },
		elements: [
			{
				id: "Power take-off",
				type: "medium",
				grid: {
					xs: { gridRow: "1", gridCol: "1" },
					sm: { gridRow: "1", gridCol: "1" },
					md: { gridRow: "1", gridCol: "1" },
					lg: { gridRow: "1", gridCol: "1" },
				},
				panelItemId: 109,
			},
			{
				id: "GovernorsAndActuators",
				type: "medium",
				grid: {
					xs: { gridRow: "6", gridCol: "1" },
					sm: { gridRow: "4", gridCol: "1" },
					md: { gridRow: "1", gridCol: "2" },
					lg: { gridRow: "1", gridCol: "2" },
				},
				panelItemId: 104,
			},
			{
				id: "EGRBlower",
				type: "medium",
				grid: {
					xs: { gridRow: "5", gridCol: "1" },
					sm: { gridRow: "1", gridCol: "3" },
					md: { gridRow: "1", gridCol: "4" },
					lg: { gridRow: "1", gridCol: "4" },
				},
				panelItemId: 101,
			},
			{
				id: "Turbocharger",
				type: "medium",
				grid: {
					xs: { gridRow: "3", gridCol: "1" },
					sm: { gridRow: "4", gridCol: "2" },
					md: { gridRow: "3", gridCol: "3" },
					lg: { gridRow: "1", gridCol: "5" },
				},
				panelItemId: 102,
			},
			{
				id: "Gearbox",
				type: "medium",
				grid: {
					xs: { gridRow: "3", gridCol: "2" },
					sm: { gridRow: "2", gridCol: "1" },
					md: { gridRow: "2", gridCol: "1" },
					lg: { gridRow: "2", gridCol: "1" },
				},
				panelItemId: 100,
			},
			{
				id: "FlexibleCoupling",
				type: "medium",
				grid: {
					xs: { gridRow: "2", gridCol: "2" },
					sm: { gridRow: "3", gridCol: "1" },
					md: { gridRow: "3", gridCol: "2" },
					lg: { gridRow: "2", gridCol: "2" },
				},
				panelItemId: 106,
			},
			{
				id: "Engine",
				type: "large",
				grid: {
					xs: { gridRow: "4 / span 1", gridCol: "1 / span 2" },
					sm: { gridRow: "2 / span 1", gridCol: "2 / span 2" },
					md: { gridRow: "2 / span 1", gridCol: "2 / span 2" },
					lg: { gridRow: "2 / span 1", gridCol: "3 / span 2" },
				},
				panelItemId: null,
				icon: "/apps/configurators/omnicare/assets/images/Engine.svg",
				text: { de: "Engine", en: "Engine" },
				className: "iam-cursor-default",
			},
			{
				id: "HydraulicPumps",
				type: "medium",
				grid: {
					xs: { gridRow: "5", gridCol: "2" },
					sm: { gridRow: "3", gridCol: "3" },
					md: { gridRow: "2", gridCol: "4" },
					lg: { gridRow: "2", gridCol: "5" },
				},
				panelItemId: 110,
			},
			{
				id: "OfflineLubricationOilFilter",
				type: "medium",
				grid: {
					xs: { gridRow: "7", gridCol: "2" },
					sm: { gridRow: "5", gridCol: "3" },
					md: { gridRow: "4", gridCol: "4" },
					lg: { gridRow: "3", gridCol: "5" },
				},
				panelItemId: 103,
			},
			{
				id: "Alternator",
				type: "medium",
				grid: {
					xs: { gridRow: "1", gridCol: "2" },
					sm: { gridRow: "4", gridCol: "3" },
					md: { gridRow: "3", gridCol: "1" },
					lg: { gridRow: "3", gridCol: "2" },
				},
				panelItemId: 107,
			},
			{
				id: "Mounts",
				type: "medium",
				grid: {
					xs: { gridRow: "6", gridCol: "2" },
					sm: { gridRow: "3", gridCol: "2" },
					md: { gridRow: "3", gridCol: "4" },
					lg: { gridRow: "3", gridCol: "4" },
				},
				panelItemId: 105,
			},
		],
		connections: [
			{ idFrom: "POWER TAKE-OFF", idTo: "Gearbox" },
			{
				idFrom: "FlexibleCoupling",
				idTo: "Gearbox",
				options: {
					md: { startDirection: "vertical" },
				},
			},
			{
				idFrom: "FlexibleCoupling",
				idTo: "Engine",
				options: {
					md: { startDirection: "vertical" },
				},
			},
			{ idFrom: "FlexibleCoupling", idTo: "Alternator" },
			{
				idFrom: "HydraulicPumps",
				idTo: "Engine",
				options: {
					xs: { startDirection: "horizontal" },
					sm: { startDirection: "horizontal" },
				},
			},
			{
				idFrom: "HydraulicPumps",
				idTo: "OfflineLubricationOilFilter",
				options: {
					xs: { startDirection: "horizontal" },
					sm: { startDirection: "horizontal" },
				},
			},
			{
				idFrom: "Mounts",
				idTo: "Engine",
				options: {
					sm: { startDirection: "horizontal" },
					md: { startDirection: "vertical" },
				},
			},
			{
				idFrom: "GovernorsAndActuators",
				idTo: "Engine",
				options: {
					xs: { startDirection: "horizontal" },
					md: { startDirection: "vertical" },
					lg: { startDirection: "vertical" },
				},
			},
			{
				idFrom: "EGRBlower",
				idTo: "Engine",
				options: {
					xs: { startDirection: "horizontal" },
					sm: { startDirection: "vertical" },
					md: { startDirection: "vertical" },
					lg: { startDirection: "vertical" },
				},
			},
			{
				idFrom: "Turbocharger",
				idTo: "Engine",
				options: {
					xs: { startDirection: "horizontal" },
					md: { startDirection: "vertical" },
					lg: { startDirection: "vertical" },
				},
			},
		],
		footer: [
			{
				id: 1,
				component: "iconCard",
				text: { de: "Systems", en: "Systems" },
				icon: "/apps/configurators/shared/assets/images/icons/info-i.svg",
				panelItemId: 2,
			},
			{
				id: 2,
				component: "iconCard",
				text: { de: "Solutions", en: "Solutions" },
				icon: "/apps/configurators/shared/assets/images/icons/info-i.svg",
				panelItemId: 3,
			},
		],
	},
	navigation: [
		{
			key: "engine",
			title: {
				en: "Engine",
				de: "Engine",
			},
			panelItems: [100, 101, 102, 103, 104, 105, 106, 107, 109, 110],
		},
		{
			key: "360-approach",
			title: {
				en: "A 360° approach",
				de: "A 360° approach",
			},
			panelItems: [2, 3],
		},
	],
};
